import { useEffect } from 'react';

export default function useImagePage({ page, activityActions }) {
  useEffect(() => {
    if (page) {
      activityActions?.onActivityProgress(page.id);
    }
  }, [page]);
}
